export type FileType = {
  url?: string;
  filename?: string;
  file?: string;
};

export const fileFormFormat = (file?: FileType | File) => {
  if (file instanceof File) {
    return {
      url: '',
      name: file.name,
    };
  }

  if (!file || !file?.filename || !file?.url) {
    return undefined;
  }

  return {
    url: file.url,
    name: file.filename,
  };
};
